import {Patient} from "../context/PatientsContext.tsx";
import {Recording, RecordingUnparsed, Transcript} from "../context/RecordingsContext.tsx";
import {BASE_URL} from "./index.ts";
import {_delete, get, post, put} from "../utils/http.ts";
import {Optional, RecordingNote} from "../utils/types.ts";

export type NewRecordingNoteBody = {
  note_type_id: number;
}

export type UpdateRecordingBody = {
  patient_id?: number;
}

export async function getUserSessions(): Promise<RecordingUnparsed[]> {
  return get<RecordingUnparsed[]>(new URL(`${BASE_URL}/recordings`));
}

export async function getFullRecording(recordingId: number): Promise<Recording> {
  return get<Recording>(new URL(`${BASE_URL}/recordings/${recordingId}`));
}

export async function getRecordingTranscription(recordingId: number): Promise<Transcript> {
  return get<Transcript>(new URL(`${BASE_URL}/recordings/${recordingId}/transcription`));
}

export async function getRecordingNote(recordingId: number): Promise<RecordingNote> {
  return get<RecordingNote>(new URL(`${BASE_URL}/recordings/${recordingId}/note`));
}

export async function getRecordingNotes(recordingId: number): Promise<RecordingNote[]> {
  return get(new URL(`${BASE_URL}/recordings/${recordingId}/notes`));
}

export async function generateNewRecordingNote(recordingId: number, body: NewRecordingNoteBody): Promise<RecordingNote> {
  return post<RecordingNote>(new URL(`${BASE_URL}/recordings/${recordingId}/notes`), { body, headers: { 'Content-Type': 'application/json' } });
}

export async function updateSession(recordingId: number, body: UpdateRecordingBody): Promise<RecordingUnparsed> {
  return put(new URL(`${BASE_URL}/recordings/${recordingId}`), { body, headers: { 'Content-Type': 'application/json' } });
}

export async function createNewRecording(rawAudios: File[], patient: Optional<Patient>): Promise<RecordingUnparsed> {
  const formData = new FormData();
  if(rawAudios.length > 1) {
    rawAudios.forEach((audio) => {
      formData.append('raw_audio_chunks', audio);
    });
  } else {
    formData.append('raw_audio', rawAudios[0]);
  }
  if(patient) formData.append('patient_id', patient.id.toString());
  return post<RecordingUnparsed>(new URL(`${BASE_URL}/recordings`), { formData });
}

export async function deleteRecording(recordingId: number): Promise<void> {
  return _delete(new URL(`${BASE_URL}/recordings/${recordingId}`));
}